import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class BackOfANapkinTemplatesCustomerValueInputModalComponent extends Component {
  @tracked customer_value = this.args.value ?? null;

  @action
  onSubmit(e) {
    e.preventDefault();
    this.args.handleFormSave(+this.customer_value);
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }

  @action
  setCustomerValue(e) {
    this.customer_value = +e.target.value;
  }

  get isDisabled() {
    if (
      this.customer_value === null ||
      this.customer_value === undefined ||
      isNaN(+this.customer_value) ||
      +this.customer_value === 0
    )
      return true;
    return false;
  }
}
